export const calculateVisibleLabels = (labelWidths, containerWidth) => {
  const totalLabelWidth = labelWidths.reduce((w, l ) => w+l, 0);
  let vEl = labelWidths.length;
  let cW = containerWidth - (totalLabelWidth > containerWidth ? 38 : 0);
  
  for(let i = 0; i < labelWidths.length; i++) {
    cW -= labelWidths[i] || 0;
    if(cW <= 0) {
      vEl = i;
      break;
    }
  }
  
  return Math.max(vEl, 0);
}